import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppService, CoreProxyService, SharedCommonService } from 'common-cloudstudio';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shared-plans',
  templateUrl: './shared-plans.component.html',
  styleUrls: ['./shared-plans.component.scss']
})
export class SharedPlansComponent implements OnInit, OnDestroy {
  genericToken: string = null;
  accessToken: string;
  facilityID: number;
  graphicalViewId: number = 0;
  timerExpired: any = null;
  subscriptions: Subscription[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    public _coreProxyService: CoreProxyService,
    private _appService: AppService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
      this.genericToken = params.genericToken;
      this.getData();
    }));
  }

  ngOnDestroy() {
    clearTimeout(this.timerExpired);
    this.timerExpired = null;
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getData() {
    if(this.timerExpired) clearTimeout(this.timerExpired);
    this._coreProxyService.GraphicalViewService.GetSharedGraphicalViewPlanData(
      this.genericToken,
      res => {
        this.accessToken = res.AccessToken;
        this.facilityID = res.FacilityID;
        this.graphicalViewId = res.ViewID;
        const expirationTime = ((res.AccessTokenExpirationSeconds*75)/10)*100;
        this.timerExpired = setTimeout(() => this.getData(), expirationTime);  
      },
      err => {
        this.timerExpired = setTimeout(() => this.getData(), 15000);
        this._appService.showException(err);
      }
    );
  }
}
